import Serializer, {
  type DeserializeArguments,
  type SerializeArguments,
} from './Serializer';
import { isHTMLElementNode } from '../helpers/serializerHelpers';
import React from 'react';
import { isEmbeddedWhiteboardElement } from '../../types/guards';
import {
  type RecordId,
  type EmbeddedWhiteboardElement,
} from '../../types/aha-editor';

const WHITEBOARD_REGEX = /\/whiteboards\/(\d+)/;

class SerializerEmbeddedWhiteboard extends Serializer {
  static deserialize({
    el,
  }: DeserializeArguments): EmbeddedWhiteboardElement | undefined {
    if (!isHTMLElementNode(el)) return;
    if (el.tagName.toLowerCase() !== 'a') return;
    const href = el.getAttribute('href');
    if (!href || !WHITEBOARD_REGEX.test(href)) return;

    const url = new URL(href);
    const searchParams = new URLSearchParams(url.search);
    const width = searchParams.get('width');
    const height = searchParams.get('height');

    const size: Partial<EmbeddedWhiteboardElement> = {};
    width && (size.resizer_width = Number(width));
    height && (size.resizer_height = Number(height));

    return {
      type: 'embedded-whiteboard',
      children: [
        {
          text: '',
        },
      ],
      ...size,
      whiteboard_id: href.match(WHITEBOARD_REGEX)![1] as RecordId,
    };
  }

  static serialize({ node, options }: SerializeArguments) {
    if (!isEmbeddedWhiteboardElement(node)) return;

    const searchParams = new URLSearchParams();
    node.resizer_width &&
      searchParams.set('width', node.resizer_width.toString());
    node.resizer_height &&
      searchParams.set('height', node.resizer_height.toString());

    return (
      <a
        href={`${options.baseURL ?? ''}/whiteboards/${
          node.whiteboard_id
        }?${searchParams.toString()}`}
      >
        Embedded whiteboard
      </a>
    );
  }
}

export default SerializerEmbeddedWhiteboard;
